import { Box, Stack, styled } from '@mui/material';

export const StyledWidgetSection = styled(Stack)(({ theme }) => {
  return `
   gap:  ${theme.spacing(0.5)};
`
})

interface StyledWidgetProps {
  hasLink?: boolean
}

export const StyledWidget = styled(Stack)(({ hasLink }: StyledWidgetProps) => {
  return `
    position: relative;
    border: 1px solid #e2ecf3;
    border-radius: 8px;
    padding: 16px 24px;
    overflow: hidden;
    gap: 8px;
    transition: ease-in-out all 0.2s;
    :hover {
      cursor: ${hasLink ? 'pointer' : 'inherit'};
      box-shadow: ${
  hasLink ? '0px 16px 24px -12px rgba(0, 0, 0, 0.24)' : 'inherit'
};
    }
  `;
});

export const StyledWidgetLabel = styled(Box)(({ theme }) => {
  return `
    font-size: 12px;
    color: ${theme.palette.grey['800']};
    font-weight: 500;
    line-height: ${theme.spacing(2)};
`;
});

export const StyledWidgetFloatingLabel = styled(StyledWidgetLabel)(() => {
  return `
    position: absolute;
    top: 8px;
`;
});

export const StyledWidgetValue = styled(Box)(({ theme }) => {
  return `
    font-size: 12px;
    color: ${theme.palette.grey['800']};
    font-weight: 500;
    line-height: ${theme.spacing(2)};
`;
});

export const StyledWidgetFloatingIcon = styled(Stack)(({ theme }) => {
  return `
    position: absolute;
    bottom: -${theme.spacing(5)};
    right: -${theme.spacing(3)};
    align-items: center;
    justify-content: center;
    width: ${theme.spacing(12)};
    height: ${theme.spacing(12)};
    font-size:${theme.spacing(7)};
    color: #8BB1E2;
`;
});

export const StyledWidgetIcon = styled(Stack)(({ theme }) => {
  return `
    position: absolute;
    bottom: -${theme.spacing(1)};
    right: ${theme.spacing(1)};
    align-items: center;
    justify-content: center;
    width: ${theme.spacing(12)};
    height: ${theme.spacing(12)};
    font-size:${theme.spacing(5)};
    color: #8BB1E2;
`
})

export const StyledWidgetContainedIcon = styled(Stack)(({ theme }) => {
  return `
    align-items: center;
    justify-content: center;
    width: ${theme.spacing(5)};
    height: ${theme.spacing(4)};
    border-radius: 4px;
    color: white;
    background-color: #8BB1E2;
`;
});

export const StyledWidgetGhostIcon = styled(Stack)(({ theme }) => {
  return `

    justify-content: center;
    width: ${theme.spacing(4)};
    height: ${theme.spacing(4)};
    color: #8BB1E2;
`;
});
